import { render } from "./InfoPopover.vue?vue&type=template&id=ace026d2"
import script from "./InfoPopover.vue?vue&type=script&lang=js"
export * from "./InfoPopover.vue?vue&type=script&lang=js"

import "./InfoPopover.vue?vue&type=style&index=0&id=ace026d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/InfoPopover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ace026d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ace026d2', __exports__)) {
    api.reload('ace026d2', __exports__)
  }
  
  module.hot.accept("./InfoPopover.vue?vue&type=template&id=ace026d2", () => {
    api.rerender('ace026d2', render)
  })

}


export default __exports__